module.exports = __webpack_public_path__ + "static/media/listening-to-your-body.3143a29d.svg";